import { createAction } from 'redux-act';
import { createAsyncAction } from "./utils";
import { FINISH_PORTAL_MIGRATION_MUTATION, GET_PORTAL_BY_ID_WITH_MIGRATION_DETAILS_QUERY, GET_PORTAL_BY_INSTITUTION_ID_QUERY, NOTIFY_PLAID_LINK_EVENT_MUTATION, REINITIALIZE_FINANCIAL_PORTAL_MUTATION } from "../lib/queries/financial-data";
export var RESET_PLAID_ONBOARDING = 'RESET_PLAID_ONBOARDING';
export var resetPlaidOnboarding = function resetPlaidOnboarding() {
  return {
    type: RESET_PLAID_ONBOARDING
  };
};
/**
 * Given a marketplace account aggregation institution id, return the associated portal for the currently
 * logged in user.
 */

export var getPortalForInstitution = createAsyncAction('getPortalForInstitution', function (_ref) {
  var marketplaceInstitutionId = _ref.marketplaceInstitutionId;
  return {
    makeRequest: function makeRequest(_state, _ref2) {
      var apolloClient = _ref2.apolloClient;
      return apolloClient.query({
        query: GET_PORTAL_BY_INSTITUTION_ID_QUERY,
        variables: {
          marketplaceInstitutionId: marketplaceInstitutionId
        },
        fetchPolicy: 'network-only'
      });
    },
    meta: {
      marketplaceInstitutionId: marketplaceInstitutionId
    }
  };
});
export var getPortalMigrationDetails = createAsyncAction('getPortalMigrationDetails', function (_ref3) {
  var portalId = _ref3.portalId;
  return {
    makeRequest: function makeRequest(_state, _ref4) {
      var apolloClient = _ref4.apolloClient;
      return apolloClient.query({
        query: GET_PORTAL_BY_ID_WITH_MIGRATION_DETAILS_QUERY,
        variables: {
          portalId: portalId
        },
        fetchPolicy: 'network-only'
      });
    },
    meta: {
      portalId: portalId
    }
  };
});
export var finishPortalMigration = createAsyncAction('finishPortalMigration', function (_ref5) {
  var portalId = _ref5.portalId;
  return {
    makeRequest: function makeRequest(_state, _ref6) {
      var apolloClient = _ref6.apolloClient;
      return apolloClient.mutate({
        mutation: FINISH_PORTAL_MIGRATION_MUTATION,
        variables: {
          portalId: portalId
        }
      });
    },
    meta: {
      portalId: portalId
    }
  };
});
export var reinitializePortal = createAsyncAction('reinitializePortal', function (financialPortalId) {
  return {
    makeRequest: function makeRequest(_state, _ref7) {
      var apolloClient = _ref7.apolloClient;
      return apolloClient.mutate({
        mutation: REINITIALIZE_FINANCIAL_PORTAL_MUTATION,
        variables: {
          financialPortalId: financialPortalId
        }
      });
    },
    meta: {
      financialPortalId: financialPortalId
    }
  };
});
export var publishLinkEvent = createAsyncAction('publishLinkEvent', function (event, eventBody) {
  var _ref8 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      financialPortalId = _ref8.financialPortalId,
      isMigrate = _ref8.isMigrate,
      marketplaceInstitutionId = _ref8.marketplaceInstitutionId,
      _ref8$source = _ref8.source,
      source = _ref8$source === void 0 ? 'PLAID' : _ref8$source,
      sourceEntityId = _ref8.sourceEntityId,
      sourceInstitutionId = _ref8.sourceInstitutionId;

  return {
    makeRequest: function makeRequest(_state, _ref9) {
      var apolloClient = _ref9.apolloClient;
      var variables = {
        event: event,
        eventBody: eventBody,
        financialPortalId: financialPortalId,
        isMigrate: isMigrate,
        marketplaceInstitutionId: marketplaceInstitutionId,
        source: source,
        sourceEntityId: sourceEntityId,
        sourceInstitutionId: sourceInstitutionId
      };
      return apolloClient.mutate({
        mutation: NOTIFY_PLAID_LINK_EVENT_MUTATION,
        variables: variables,
        fetchPolicy: 'no-cache'
      });
    },
    meta: {
      event: event,
      financialPortalId: financialPortalId
    }
  };
});
export var startRelink = createAction('startRelink');
export var chooseUnavailableProvider = createAction('chooseUnavailableProvider');
export var setIsYodleeToPlaidMigrationEnabled = createAction('setIsYodleeToPlaidMigrationEnabled');
/**
 * @deprecated -- this functionality is always on
 */

export var setIsPlaidLinkFirstEnabled = createAction('setIsPlaidLinkFirstEnabled');